import { IoMdClose } from "react-icons/io";

export default function TwoPopuP({
  TwoPopUp,
  setTwoPopUp,
  demobilization_type,
  updateData,
}) {
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          TwoPopUp ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setTwoPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
            <h1>
              By Clicking Proceed , The employee will reflect in - 
              {demobilization_type}
            </h1>
          </div>
          <div className="w-full">
            <div className="w-full flex flex-col gap-3 my-3 p-5">
              <div className="flex gap-3 w-full justify-center">
                <button
                  className="p-3 bg-blue text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
                  onClick={() => {
                    updateData();
                  }}
                >
                  Procced
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
